import React, { useEffect, useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { navLinks, siteInfo } from '../mock';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-[#faf7f2]/95 backdrop-blur-md border-b border-[#e8e1d2] py-3'
          : 'bg-transparent py-6'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between">
        <a href="#top" className="flex flex-col leading-tight">
          <span
            className={`font-display text-2xl md:text-[26px] tracking-tight ${
              scrolled ? 'text-[#2f3d30]' : 'text-[#faf7f2]'
            }`}
          >
            Ljungdalens
          </span>
          <span
            className={`text-[10px] md:text-[11px] uppercase tracking-[0.3em] -mt-1 ${
              scrolled ? 'text-[#8a8572]' : 'text-[#e8e1d2]/90'
            }`}
          >
            Turridning
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className={`nav-link text-[13px] uppercase tracking-[0.18em] font-medium ${
                scrolled ? 'text-[#2f3d30]' : 'text-[#faf7f2]'
              }`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href={`tel:${siteInfo.phone}`}
          className={`hidden lg:inline-flex items-center gap-2 text-[13px] font-medium tracking-wide transition-colors ${
            scrolled ? 'text-[#2f3d30] hover:text-[#1f2a20]' : 'text-[#faf7f2] hover:text-[#e8d8b4]'
          }`}
        >
          <Phone className="w-4 h-4" strokeWidth={1.5} />
          {siteInfo.phone}
        </a>

        <button
          className={`lg:hidden ${scrolled ? 'text-[#2f3d30]' : 'text-[#faf7f2]'}`}
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-[#faf7f2] border-t border-[#e8e1d2] mt-3">
          <div className="px-6 py-6 flex flex-col gap-5">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-[#2f3d30] text-[13px] uppercase tracking-[0.18em] font-medium"
              >
                {l.label}
              </a>
            ))}
            <a
              href={`tel:${siteInfo.phone}`}
              className="flex items-center gap-2 text-[#2f3d30] text-sm font-medium mt-2"
            >
              <Phone className="w-4 h-4" /> {siteInfo.phone}
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
